// useMyWorkspaces.ts — workspace-members cycle (THI-110 Task 5). Every workspace the signed-in
// user belongs to, carrying their role — the one client-side source the rail's workspace menu
// (role-gate Members/Billing) and `Members.tsx`/`InviteAccept.tsx` (whose row is "mine") read instead of
// re-deriving membership from a session object that doesn't carry it. Same shape as
// `useBots.ts`/`useBillingSummary.ts`: a plain `useQuery` wrapper, `staleTime` long enough that
// mounting it from both the account menu (every route) and a page body doesn't double-fetch.
import { useQuery } from '@tanstack/react-query';
import type { MyWorkspaceDto } from '@repo/shared-types';
import { apiFetch } from '../lib/api';

export function useMyWorkspaces() {
  return useQuery({
    queryKey: ['me', 'workspaces'],
    queryFn: () => apiFetch<MyWorkspaceDto[]>('/api/me/workspaces'),
    staleTime: 60_000,
  });
}
